function initializeSelect2($el, data = []) {
    if (typeof $.fn.select2 !== 'function') {
        console.error('Select2 NO está disponible. Revisa imports en application.js');
        console.log('jQuery presente?', typeof $ === 'function');
        console.log('$.fn.select2?', typeof $.fn.select2);
        return;
    }

    // Destruye si ya existe (evita duplicados en turbolinks)
    if ($el.hasClass('select2-hidden-accessible')) {
        $el.select2('destroy');
    }

    $el.select2({
        data: data,
        tokenSeparators: [',', ' '],
        theme: "classic",
        width: 'resolve'
    });

    console.log('Select2 inicializado OK en:', $el.attr('id'));
}
function checkAndFetchModel() {
    const brand_id = $('#parent_brand_id').val();
    const bci_id = $('#parent_bci_id').val();
    $('#models').val(null)
    $('#battery_model_id').empty();
    $('#battery_model_id').val(null).trigger('change')
    if (brand_id && bci_id) {
        fetchModel(brand_id, bci_id, $('#parent_name').val(), $('#parent_type').val());
    }
}
function setModel() {
    let models = JSON.parse($('#models').val())
    let modelId = $('#battery_model_id').val()
    if(models && modelId){
        let data = models.filter(m => ''+m.id === ''+$('#battery_model_id').val())[0]
        data['name'] && invalidString(name) && $('#parent_name').val(data['name'])
        data['c_a'] && $('#parent_ca').val(data['c_a']);
        data['c_c_a'] && $('#parent_cca').val(data['c_c_a']);
        data['reserve_capacity_min'] && $('#parent_reserve_capacity_min').val(data['reserve_capacity_min']);
        data['list_price_iva'] && $('#parent_list_price_iva').val(data['list_price_iva']);
        data['list_price'] && $('#parent_list_price').val(data['list_price']);
        data['warranty'] && $('#parent_warranty').val(data['warranty']);
        data['warranty_fleet'] && $('#parent_warranty_fleet').val(data['warranty_fleet']);
        data['weight'] && $('#parent_weight').val(data['weight']);
        data['plates'] && $('#parent_plates').val(data['plates']);
        data['volts'] && $('#parent_volts').val(data['volts']);
        data['length'] && $('#parent_length').val(data['length']);
        data['width'] && $('#parent_width').val(data['width']);
        data['high'] && $('#parent_high').val(data['high']);
    }
}
function fetchModel(brand_id, bci_id, name) {
    const url = '/get/battery/models'
    $.get(url, {brand_id: brand_id, bci_id: bci_id}, function(data) {
        if (data) {
            if(data.models) {
                $('#models').val(JSON.stringify(data.models))
            }
            initializeSelect2($('#battery_model_id'), data.selectable);
            setModel()
        } else {
            cwarn('empty model data.')
        }
    });
}

function fetchGroup() {
    const bci_id = $('#parent_bci_id').val();
    const url = '/get/bci/group/'+bci_id;
    // $.get(url, {name: name, type: type}, function(data) {
    $.get(url, {}, function(data) {
        if (data) {
            data['batteries_groups_id'] && $('#battery_group_id').val(data['batteries_groups_id']).trigger('change');
        } else {
            cwarn('empty bci group.')
        }
    });
}

$(document).on('change', '#parent_list_price', setPriceIva)
$(document).off('change', '#parent_list_price', setPriceIva)
function setPriceIva() {
    let value = $('#parent_list_price').val()
    if(!undefinedOrNull(value) && value !== ''){
        $('#parent_list_price_iva').val(parseInt(value)*1.16)
    }
}

function destroyBatteriesBatch() {
    if (!document.getElementById('new_batch')) return;
    // $('#parent_bci_id').off('select2:select', fetchGroup);
    // $('#parent_group_id, #parent_brand_id, #parent_bci_id').off('select2:select', checkAndFetchModel);
    // $('#parent_name, #parent_type').off('change', checkAndFetchModel);
    // $('#battery_model_id').off('select2:select', setModel);
    $(document).off('select2:select', '#parent_bci_id', fetchGroup);
    $(document).off('select2:select', '#parent_group_id, #parent_brand_id, #parent_bci_id', checkAndFetchModel);
    $(document).off('select2:select', '#battery_model_id', setModel);
    $(document).off('change', '#parent_name, #parent_type', checkAndFetchModel);
    $(document).off('change', '#parent_list_price', setPriceIva);
    // Destruir instancias de select2 (muy importante para evitar estados corruptos)
    $('#battery_model_id').select2('destroy'); // si ya estaba inicializado

    // Limpiar campos ocultos si es necesario
    $('#models').val(null);

    console.log("Batteries batch destroyed");
}

function setupBatteriesBatch() {
    if (!document.getElementById('new_batch')) return;
    // $('#parent_bci_id').on('select2:select', fetchGroup);
    // $('#parent_group_id, #parent_brand_id, #parent_bci_id').on('select2:select', checkAndFetchModel);
    // $('#battery_model_id').on('select2:select', setModel);
    // $('#parent_name, #parent_type').on('change', checkAndFetchModel);
    $(document).on('select2:select', '#parent_bci_id', fetchGroup);
    $(document).on('select2:select', '#parent_group_id, #parent_brand_id, #parent_bci_id', checkAndFetchModel);
    $(document).on('select2:select', '#battery_model_id', setModel);
    $(document).on('change', '#parent_name, #parent_type', checkAndFetchModel);
    $(document).on('change', '#parent_list_price', setPriceIva)

    // Inicializar select2 solo si NO está ya inicializado
    if (!$('#battery_model_id').hasClass('select2-hidden-accessible')) {
        initializeSelect2($('#battery_model_id'));
    }
    checkAndFetchModel();
}


// TODO: Binding global (solo una vez)
$(document).on('turbolinks:load', setupBatteriesBatch);
$(document).on('turbolinks:before-cache', destroyBatteriesBatch);
// TODO: Remove old loads
// $(document).on('turbolinks:load', setupBatteriesBatch)
// window.addEventListener('beforeunload', (event) => {
//     destroyBatteriesBatch();
// });

window.checkAndFetchModel = checkAndFetchModel;
window.fetchModel = fetchModel;
